import { Btn, BtnGreen, BtnNormal } from "./localStyle";

const BtnLink = ({
  to,
  title,
  Icon,
  type,
  onclick,
  spacingWord,
  textCentre,
  normalFont,
}) => {
  switch (type) {
    case "LINK":
      return (
        <Btn to={to}>
          {" "}
          {Icon} <span>{title}</span>
        </Btn>
      );
    case "NORMAL":
      return (
        <BtnNormal
          normalFont={normalFont}
          textCentre={textCentre}
          spacingWord={spacingWord}
          onClick={onclick}
        >
          {Icon} <span>{title}</span>
        </BtnNormal>
      );
    case "GREEN":
      return (
        <BtnGreen spacingWord={spacingWord} onClick={onclick}>
          {Icon} <span>{title}</span>
        </BtnGreen>
      );

    default:
      return (
        <Btn to={to}>
          {" "}
          {Icon} <span>{title}</span>
        </Btn>
      );
  }
};

export default BtnLink;

// BtnNormal
